import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '../services/user/user.service';
import { EnlistmentService } from '../services/enlistment/enlistment.service';


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  showloginscreen : boolean;
  showregisterscreen : boolean;
  staticText : string;

  showforgotscreen: boolean;
  isLoginError: boolean = false;
  isLoading: boolean = false;
  isRegisterSuccess: boolean = false;

  constructor(private router : Router, private userService : UserService, 
    private enlistmentServices : EnlistmentService) { }

  ngOnInit() {
    this.showloginscreen = true;
    this.showregisterscreen = false;
    this.showforgotscreen = false;

    if(localStorage.getItem("userToken") != null)
    {
        this.router.navigate(['/dashboard']);
    }
    else{
      //this.userService.purgeAuth();
    }

    this.enlistmentServices.getStaticData().subscribe(
      (data : any) =>
      {
        this.staticText = data;
        console.log(this.staticText);
      }
    )

  }

  // ShowRegister()
  // {
  //   this.showloginscreen = false;
  //   this.showregisterscreen = true;
  // }
  // ShowLogin()
  // {
  //   this.showloginscreen = true;
  //   this.showregisterscreen = false;
  // }

  ShowLogin() {
    this.showloginscreen = true;
    this.showregisterscreen = false;
    this.showforgotscreen = false;
  }

  OnForgotSubmit(Email) {
    this.isLoading = true;
    this.isRegisterSuccess = false;
    this.isLoginError = false;

    this.userService.ForgotPassword(Email).subscribe(
      (data: any) => {
        if (data == true) {
          this.isLoading = false;
          this.isRegisterSuccess = true;
          this.isLoginError = false;
        }
        else {
          this.isLoading = false;
          this.isRegisterSuccess = false;
          this.isLoginError = true;
        }
      }
    )

    this.isLoading = false;
    this.isRegisterSuccess = true;
    this.isLoginError = false;

  }
  
}
